import { desktopSmall, mobile, tablet, tv } from 'app/device';
import styled, { css } from 'styled-components';

export const GamesWrapper = styled.div.attrs(() => ({
    id: 'GamesWrapper',
}))`
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    padding-top: ${(props) => (props.isDiscoveryOffer ? '8rem' : '0')};

    ${tv(css`
        width: 100vw;
    `)}

    ${mobile(css`
        width: 100vw;
    `)}

    overflow-x: hidden;
    overflow-y: auto;

    &::-webkit-scrollbar {
        width: 0 !important;
    }

    scroll-behavior: smooth;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
`;

export const LeadingGame = styled.div`
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    margin: 0 auto;
    height: 60vh;
    flex-shrink: 0;
    padding-bottom: 50px;
    width: 100%;

    ${desktopSmall(css`
        height: 80vh;
        padding-bottom: 30px;
    `)}

    ${mobile(css`
        height: 70vh;
        padding-bottom: 20px;
    `)}

    ${tablet(css`
        height: 80vh;
        padding-bottom: 20px;
    `)}

  ${tv(css`
        height: 65vh;
    `)}
`;

export const NoGamesFound = styled.div`
    margin-top: ${(props) => (props.small ? '10vh' : '30vh')};
    font-size: 2rem;
    text-align: center;
    ${mobile(css`
        font-size: 1.4rem;
    `)}
`;
